// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reject-document{width:530px}.reject-document .modal__header{padding-left:24px;padding-right:24px}.reject-document p{margin-bottom:8px}`, "",{"version":3,"sources":["webpack://./src/modals/RejectDocument/style.scss","webpack://./src/style/variables.scss"],"names":[],"mappings":"AACA,iBACE,WAAA,CAEA,gCACE,iBAAA,CACA,kBAAA,CAGF,mBACE,iBC+JS","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
